import { render, staticRenderFns } from "./ApartmentStatusLabel.vue?vue&type=template&id=e2e278fc&scoped=true&"
import script from "./ApartmentStatusLabel.vue?vue&type=script&lang=ts&"
export * from "./ApartmentStatusLabel.vue?vue&type=script&lang=ts&"
import style0 from "./ApartmentStatusLabel.vue?vue&type=style&index=0&id=e2e278fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e278fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2e278fc')) {
      api.createRecord('e2e278fc', component.options)
    } else {
      api.reload('e2e278fc', component.options)
    }
    module.hot.accept("./ApartmentStatusLabel.vue?vue&type=template&id=e2e278fc&scoped=true&", function () {
      api.rerender('e2e278fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apartment/components/ApartmentStatusLabel.vue"
export default component.exports